import {
  DAYS_OF_WEEK_LONG_LABELS,
  DAYS_OF_WEEK_SHORT_LABELS,
  TIMES_OF_DAY_LABELS,
} from '@lyrahealth-inc/shared-app-logic/src/features/searchForCare/messages'

export type AvailabilityCalendarProps = {
  childComponentValues: string[]
  setChildComponentValues: (e: React.SetStateAction<string[]>) => void
  handleChildComponentChange: (value: (string | boolean)[]) => void
  customDaysToDisplay?: { defaultMessage: string; description: string }[]
}

// Define constants to create grid
export const DAYS_OF_WEEK = [
  DAYS_OF_WEEK_SHORT_LABELS.Mon,
  DAYS_OF_WEEK_SHORT_LABELS.Tue,
  DAYS_OF_WEEK_SHORT_LABELS.Wed,
  DAYS_OF_WEEK_SHORT_LABELS.Thu,
  DAYS_OF_WEEK_SHORT_LABELS.Fri,
  DAYS_OF_WEEK_SHORT_LABELS.Sat,
  DAYS_OF_WEEK_SHORT_LABELS.Sun,
]

export const DAYS_OF_WEEK_SUNDAY_FIRST = [
  DAYS_OF_WEEK_LONG_LABELS.Sunday,
  DAYS_OF_WEEK_LONG_LABELS.Monday,
  DAYS_OF_WEEK_LONG_LABELS.Tuesday,
  DAYS_OF_WEEK_LONG_LABELS.Wednesday,
  DAYS_OF_WEEK_LONG_LABELS.Thursday,
  DAYS_OF_WEEK_LONG_LABELS.Friday,
  DAYS_OF_WEEK_LONG_LABELS.Saturday,
]
export const TIMES_OF_DAY = [TIMES_OF_DAY_LABELS.Morning, TIMES_OF_DAY_LABELS.Afternoon, TIMES_OF_DAY_LABELS.Evening]

export const generateSlotPosition = ({ dayIndex, timeIndex }: { dayIndex: number; timeIndex: number }) => {
  return `${dayIndex}-${timeIndex}`
}

export const isSlotSelected = ({
  dayIndex,
  timeIndex,
  currentValue,
}: {
  dayIndex: number
  timeIndex: number
  currentValue: string[]
}) => {
  return currentValue.includes(generateSlotPosition({ dayIndex, timeIndex }))
}
